<template>
  <footer class="bg-primary sombra">
    <div class="container">
      
      <div class="espacio">

        <div class="logoKia">
          <img 
            src="@/assets/images/Logo-Kia.png" 
            alt="KIA LOGO" 
            style="padding-top: 1rem" 
          />
          
          <div>
            <a :href="facebook" target="_blank">
              <span class="fa-stack fa-sm">
                <i style="color: white" class="fab fa-facebook-f fa-stack-1x"></i>
              </span>
            </a>
            
            <a :href="youtube" target="_blank">
              <span class="fa-stack fa-sm">
                <i style="color: white" class="fab fa-youtube fa-stack-1x"></i>
              </span>
            </a>

            <a :href="instagram" target="_blank">
              <span class="fa-stack fa-sm">
                <i style="color: white" class="fab fa-instagram fa-stack-1x"></i>
              </span>
            </a>

            <a :href="twitter" target="_blank">
              <span class="fa-stack fa-sm">
                <i style="color: white" class="fab fa-twitter fa-stack-1x"></i>
              </span>
            </a>
          </div>
          
          <!-- <div class="pt-3 ml-4 ml-md-0">
            <div class="animated fadeIn">
              <h5 class="kt-wizard-v1__nav-label">Contacto</h5>
              <h6 class="kt-wizard-v1__nav-label">{{ correo }}</h6>
            </div>
            
            <div class="animated fadeIn">
              <h6 class="kt-wizard-v1__nav-label">{{ telefono }}</h6>
            </div>
          </div> -->

        </div>

        <div class="links">
          <ul>
            <li v-for="item in tipoPaginas" :key="item.label">
              <h3>
                <a :href="item.url" target="_blank">
                  <h6 
                    style="color:white; font-size: 15px;" 
                    class="kt-wizard-v1__nav-label">
                    {{ item.label }}
                  </h6>
                </a>
              </h3>
            </li>
          </ul>
        </div>

      </div>
      
    </div>
  </footer>
</template>

<script>
import constantes from "../constantes";
export default {

  name: "Footer",
  data: () => ({
    facebook: process.env.VUE_APP_FACEBOOK_URL,
    twitter: process.env.VUE_APP_TWITTER_URL,
    instagram: process.env.VUE_APP_INSTAGRAM_URL,
    youtube: process.env.VUE_APP_YOUTUBE_URL,
    correo: process.env.VUE_APP_CORREO,
    telefono: process.env.VUE_APP_TELEFONO,
    tipoPaginas: constantes.Constantes.tipoPaginas,

  }),
};
</script>

<style scoped>
footer {
  height: auto;
}

.logo-foo {
  max-width: 8em;
  margin-left: auto;
}

.sombra {
  -webkit-box-shadow: 0px -2px 81px -10px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0px -2px 81px -10px rgba(0, 0, 0, 0.8);
  box-shadow: 0px -2px 81px -10px rgba(0, 0, 0, 0.8);
}

.espacio {
  display: flex;
  justify-content: space-between;
}

.logoKia {
  width: 40%
}

.links {
  width: 35%;
  padding-top: 1rem;
}
</style>

